/**
 * mpg.js — MPG Autocomplete Panel Template
 *
 * - Defines the panel layout rendered by autocomplete-js's custom render() hook
 * - querySuggestions is injected by autocomplete-js from the source system
 * - The initial content carousel is populated separately by mountAutocompleteCarousel()
 *   after config.onOpen() resolves.
 * - Checks for the brand determined query length minimum before rendering search results
 */
import { algoliaConfig } from '../../_config';
import { getBrand } from '../../_getBrand';

export function autocompletePanel_MPG({ elements, state, render, html }, root) {
  const brand = getBrand();
  const config = algoliaConfig[brand];
  const isSearching = state.query.length >= config.autocomplete.debounceChars;
  const combinedHits = Number(state.context.productsNbHits) + Number(state.context.collectionsAndPagesNbHits);
  const nbHits = combinedHits ? combinedHits : "";

  let seeAllLink = html`
    <a 
      href="/search?q=${encodeURIComponent(state.query)}" 
      class="link ac-see-all"
    >
      See all ${nbHits} results
    </a>
  `;

  let seeAllButton = html`
    <a 
      href="/search?q=${encodeURIComponent(state.query)}" 
      class="button ac-see-all"
    >
      See all ${nbHits} results
    </a>
  `;

  render(html`
    <div class="ac-panel">
      <div class="ac-results__suggestions">
        ${elements.querySuggestions}
      </div>

      ${isSearching ? html`
        <section class="ac-results__products">
          <div class="ac-results__products__header-wrap">
            <div class="aa-SourceHeader">Products</div>
            <div class="aa-SourceLink">${nbHits > 1 ? seeAllLink : ''}</div>
          </div>
          <div id="autocompleteCarouselProducts" class="splide" aria-label="Search Results Carousel">
            <div class="splide__track">
              <ul class="splide__list"></ul>
            </div>
          </div>
          <div class="aa-SourceFooter">
            <div class="aa-SourceLink">${nbHits > 1 ? seeAllButton : ''}</div>
          </div>
        </section>

        <div class="ac-results__collections-pages">
          ${elements.collectionsAndPages}
        </div>
        
      ` : html`        
        <div class="ac-results__initial-content">
          <div class="aa-SourceHeader">Popular Styles</div>
          <div id="autocompleteCarouselInitial" class="splide" aria-label="Popular Styles Carousel">
            <div class="splide__track">
              <ul class="splide__list"></ul>
            </div>
          </div>
        </div>

        <div class="ac-results__collections-pages"></div>
      `}
    </div>
  `, root);

  // After render, ensure autocomplete-created source nodes are placed
  // into the correct brand columns. Autocomplete may create these nodes
  // on initial idle render (bestsellers) and leave them attached there;
  // move them into the searching grid when needed.
  setTimeout(() => {
    const collectionsPagesNode = document.querySelector('[data-autocomplete-source-id="collectionsAndPages"]');
    const productsNode = document.querySelector('[data-autocomplete-source-id="products"]');
    const collectionsTarget = root.querySelector('.ac-results__collections-pages');
    const productsTarget = root.querySelector('.ac-results__products');

    if (collectionsPagesNode && collectionsTarget) collectionsTarget.appendChild(collectionsPagesNode);
    if (productsNode && productsTarget) productsTarget.appendChild(productsNode);
  }, 0);
}